import { BillingRules } from './billing-rules.model';
import { CoParticipation } from './co-participation.model';
import { Payments } from './payments.model';

export interface BenefitsResponse {
	benefits: BenefitSummary[];
}

export interface BenefitResponse {
	id: string;
	accommodation: 'APARTAMENTO' | 'ENFERMARIA';
	co_participation: CoParticipation;
	code_ans: string;
	coin?: string;
	coverage: 'ESTADUAL' | 'NACIONAL' | 'REGIONAL';
	lack_ans: boolean;
	multiple?: number;
	name: string;
	partner_id: string;
	partner_name: string;
	payments: Payments;
	queries?: number;
	rules_billing: BillingRules;
	type: 'CONJUGATED' | 'DEFAULT' | 'DENTAL' | 'HEALTH';
}

export interface BenefitSummary {
	id: string;
	accommodation?: string;
	coverage?: string;
	name: string;
	partner: string;
	type: 'CONJUGATED' | 'DEFAULT' | 'DENTAL' | 'HEALTH';
}

export interface BenefitRegistration {
	id: string;
	accommodation: 'APARTAMENTO' | 'ENFERMARIA';
	co_participation: CoParticipation;
	code_ans: string;
	coin?: string;
	coverage: 'ESTADUAL' | 'NACIONAL' | 'REGIONAL';
	lack_ans: boolean;
	multiple?: number;
	name: string;
	partner: string;
	payments: Payments;
	queries?: number;
	rules_billing: BillingRules;
	type: 'CONJUGATED' | 'DEFAULT' | 'DENTAL' | 'HEALTH';
}

export interface BenefitRequest {
	accommodation: 'APARTAMENTO' | 'ENFERMARIA';
	co_participation: CoParticipation;
	code_ans: string;
	coin: string;
	coverage: 'ESTADUAL' | 'NACIONAL' | 'REGIONAL';
	lack_ans: boolean;
	multiple: number;
	name: string;
	partner: string;
	payments: Payments;
	queries: number;
	rules_billing: BillingRules;
	type: 'CONJUGATED' | 'DEFAULT' | 'DENTAL' | 'HEALTH';
}

export type BenefitType = 'CONJUGATED' | 'DEFAULT' | 'DENTAL' | 'HEALTH';

export const COVERAGE: string[] = ['ESTADUAL', 'REGIONAL', 'NACIONAL'];

export const ACCOMODATION: string[] = ['APARTAMENTO', 'ENFERMARIA'];

export const DISMISS_RETIRED = [
	{ label: 'Pagamento direto', value: 'PAGAMENTO_DIRETO' },
	{ label: 'Pagamento empresa', value: 'PAGAMENTO_EMPRESA' },
];
